export default {
  COUNTIES_FETCH_START: 'COUNTIES_FETCH_START',
  COUNTIES_FETCH_SUCCESS: 'COUNTIES_FETCH_SUCCESS',
  COUNTIES_FETCH_FAILURE: 'COUNTIES_FETCH_FAILURE',
}
